module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.backBtn),
      expression: "backBtn"
    }],
    staticClass: "button-back",
    on: {
      "click": _vm.back
    }
  }, [_c('img', {
    attrs: {
      "src": "media/global/btn_back.png"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "button-title"
  }, [_vm._v(_vm._s(_vm.items.globalButtons.backButton))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-04768229"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ButtonBack.vue
// module id = 122
// module chunks = 0